import { SWRFetcher } from '@commenda/utils';
import useSWR from 'swr';

export function useBillingPricingConfig() {
  const { data, error, isLoading, mutate } = useSWR<{
    id: string;
    monthlyPremiumBps: number;
    quarterlyPremiumBps: number;
  } | null>('commenda-billing/catalog/config', SWRFetcher({ method: 'GET' }));

  return { config: data ?? null, error, isLoading, mutate };
}
